import { Button } from '@mm/components';
import React from 'react';
import { useHistory } from 'react-router';
import { BookDemoButton } from '../../../../common/buttons/BookDemoButton/BookDemoButton';
import { SIGNUP } from '../../../../common/constants/routes';
import { SMART_ID_UTM } from '../../XRayOnboarding/WebsiteReportSummary/constants';
import styles from './DemoButtons.module.css';

export const DemoButtons = ({ isMobile }) => {
  const history = useHistory();

  return (
    <div className={styles.wrapper}>
      <div className={styles.demo_buttons}>
        <Button
          size={isMobile ? 'md' : 'lg'}
          css={{ container: styles.demo_buttons__button }}
          onClick={() => {
            history.push(SIGNUP);
          }}
        >
          Try it Free
        </Button>
        <BookDemoButton
          button=" Request Demo"
          utm={SMART_ID_UTM}
          className={styles.demo_buttons__button}
          show
        />
      </div>
      <p className={styles.note}>No Credit Card Required.</p>
    </div>
  );
};
